import React from 'react';
import styled from 'styled-components';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
import KnowledgeAreasChart from '../KnowledgeAreasChart';
import { getDimensionFullName } from '../constants';
import icono from '../imgs/icons/edu_iconos_binoculars.svg';

export const ChartWrapper = styled.div`
  margin-bottom: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
  width: 100%;
`;

const VocationOneKnowledgeAreasGraphPage = ({ user, background, number }) => {
  const { TOP_DIM_3, TOP_DIM_4, THIRD_AREA_ITEMS, FOURTH_AREA_ITEMS } = user;
  // console.log({ TOP_DIM_1, TOP_DIM_2 });
  const thirdDimName = getDimensionFullName(TOP_DIM_3);
  const fourthDimName = getDimensionFullName(TOP_DIM_4);
  // console.log({ TOP_DIM_3, TOP_DIM_4 });
  // console.log({FIRST_AREA_ITEMS, THIRD_AREA_ITEMS})
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          {TOP_DIM_3 && (
            <>
              <p className='justified'>
                En la figura de más abajo verás tu nivel de interés en las áreas
                de conocimiento que se relacionan más directamente con tu
                preferencia por actividades de <strong>{thirdDimName}</strong>
              </p>

              <ChartWrapper>
                <KnowledgeAreasChart
                  user={user}
                  order='THIRD'
                  areas={THIRD_AREA_ITEMS.map(area =>
                    area.replace('_THIRD_SUM', '')
                  )}
                />
              </ChartWrapper>
            </>
          )}

          {TOP_DIM_4 && (
            <>
              <p className='justified'>
                En la figura de más abajo verás tu nivel de interés en las áreas
                de conocimiento que se relacionan más directamente con tu
                preferencia por actividades de <strong>{fourthDimName}</strong>
              </p>

              <ChartWrapper>
                <KnowledgeAreasChart
                  user={user}
                  order='FOURTH'
                  areas={FOURTH_AREA_ITEMS.map(area =>
                    area.replace('_FOURTH_SUM', '')
                  )}
                />
              </ChartWrapper>
            </>
          )}

          <br />
          <br />
          <br />
          <br />
          <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: -45, left: -25 }}>
              <img
                src={icono}
                alt='icono binoculares'
                style={{ width: 100, height: 'auto' }}
              />
            </div>
            <div className='edu-bubble-group bg-edu-red'>
              <p className='justified'>
                El test evalúa por separado tu nivel de interés en las áreas
                académicas relacionadas con tus dos o tres preferencias
                principales. Por eso, puede ocurrir que una o más áreas de
                conocimiento se repitan entre los gráficos, pero con puntajes
                diferentes. Esto no es un error: refleja que tu interés por una
                misma área puede ser más alto cuando se compara con ciertas
                alternativas, y más bajo cuando se compara con otras.{' '}
                <strong>
                  Revisar ambos gráficos en conjunto te permitirá tener una
                  visión más completa de las áreas que te atraen, y en qué
                  contextos se conectan mejor con tus intereses.
                </strong>
              </p>
            </div>
          </div>

          {/* <p className='justified small'>
            <em>Nota. </em>
            Los resultados anteriores muestran en qué área académica te
            resultaría más atractivo trabajar para desplegar cada una de tus
            preferencias vocacionales prioritarias. Por esto, si bien un área
            académica puede resultarte poco interesante al relacionarla con una
            de tus preferencias prioritarias, esta misma área puede ser más
            interesante al relacionarla con otra de tus áreas de preferencia (o
            viceversa).
          </p> */}
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationOneKnowledgeAreasGraphPage;
